// extracted by mini-css-extract-plugin
export default {"modalContent":"_4vYwmmLLdoi38jakXwLn"};